export default {
  startLoading: state => (state.isLoading = true),
  finishLoading: state => {
    state.isLoading = false,
    state.lastCallElementToOnBlur = null
  },
  callElementToOnBlur: (state, payload) => (state.lastCallElementToOnBlur = payload)
};
